import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { alertQuestionnaireTemplate } from '../data/htmlTemplates.js';

import L from 'leaflet';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";

import { Sesion, Datos, Layers, obtenerURL } from '../main.js';
import { getLiteral} from './util.js';
import { getGrid, getGridBounds } from './grid.js';
import { discoverPatchesInCell, processPatches, discoverPlotsInCell } from './dataManager.js';
import { pintarProvincias, quitarProvincias } from './provinces.js';
import { pintarTeselas, quitarTeselas, popupTesela } from './patches.js';
import { pintarParcelas, quitarParcelas, popupParcela, ajustarColorParcelas } from './plots.js';
import { pintarArboles, quitarArboles } from './trees.js';
import { initMapEvent, sendTimedEvent, sendMapTimeoutEvent, setEventData } from './events.js';


// variables globales
let Mimapa, Mitilelayer;
let tostadaIFN2pend = true;

//////////////////////
// INICIALIZACIÓN MAPA
function inicializarMapa() {
	// CARGO MAPA CON LA LOCALIZACIÓN DE LA CONFIGURACIÓN

	// alternativas de mapas
	// https://leaflet-extras.github.io/leaflet-providers/preview/

	// meto tap: false, que parece es una fuente de problemas
	// nov-23: pongo preferCanvas: true que mejora mucho el borrado (y el resto parece que sigue bien), también pongo doubleClickZoom: false
	// dec-23: incluyo scrollWheelZoom: 'center' para reducir saltos raros con el zoom en el ratón de Apple
	// feb-25: desactivo lo del scrollWheelZoom, parece que no tiene demasiado impacto con el ratón de Apple como creía
	Mimapa = L.map('mimapa', {maxBounds: config.geoMaxBounds, maxBoundsViscosity: config.geoMaxBoundsViscosity, zoomControl: false, tap: false, 
		doubleClickZoom: false, //scrollWheelZoom: 'center', 
		wheelDebounceTime: 100, preferCanvas: true} )
		.setView([Sesion.estado.loc.lat, Sesion.estado.loc.lng], Sesion.estado.loc.z);
	// cargo el tile layer que corresponda tras cargar la URL
	const gc = obtenerConfigMapaBase();
	Mitilelayer = gc.wms? L.tileLayer.wms(gc.url, gc.options).addTo(Mimapa) : L.tileLayer(gc.url, gc.options).addTo(Mimapa);
	
	// REPOSICIONO CONTROLES DE ZOOM Y MUESTRO ESCALA DEL MAPA
	L.control.scale( {imperial: false, position: 'bottomright'} ).addTo(Mimapa); // sin la escala imperial
	if (!L.Browser.mobile) { // sólo botones de zoom para dispositivos no móviles
		L.control.zoom( { position: 'bottomright',
			zoomInTitle: getLiteral(dict.zoomin),
			zoomOutTitle: getLiteral(dict.zoomout),
		} ).addTo(Mimapa);
	}
	
	// REGENERACIÓN DE POPUPS DE TESELAS Y PARCELAS
	Mimapa.on("popupopen", function(e) {
		// cojo el DOM element del popup
		//const popel = e.popup.getElement();
		// si hay un popup con clase ".popup", procesamos
		const divpopel = e.popup.getElement().querySelector(".popup");
		if (divpopel) {
			// cojo la latlng 
			const latlng = e.popup.getLatLng();
			// extraigo la iri
			const iri = divpopel.getAttribute("iri");
			// si es una parcela y hay que regenerarla
			if (divpopel.classList.contains("plot") && Sesion.parPopupsRegenerar[iri]) {
				// elimino de los pendientes
				delete Sesion.parPopupsRegenerar[iri]; 
				// cierro este popup
				Mimapa.closePopup();
				// regenero y abro
				const popup = popupParcela(Datos.parcelas[iri]); // obtengo el popup
				if (Array.isArray(Sesion.parPintadas[iri])) {
					for (let sc of Sesion.parPintadas[iri])
						sc.bindPopup(popup, {maxWidth: 800});
					Sesion.parPintadas[iri][0].openPopup(latlng);
				}
				else {
					Sesion.parPintadas[iri].bindPopup(popup, {maxWidth: 800});
					Sesion.parPintadas[iri].openPopup(latlng);
				}		
			} // si es una tesela y hay que regenerarla...
			else if (divpopel.classList.contains("patch") && Sesion.tesPopupsRegenerar[iri]) {
				// elimino de los pendientes
				delete Sesion.tesPopupsRegenerar[iri]; 
				// cierro este popup
				Mimapa.closePopup();
				// regenero y abro
				const popup = popupTesela(Datos.teselas[iri]); // obtengo el popup
				Sesion.tesPintadas[iri].bindPopup(popup).on({
					popupopen: function(e) { // realce
						let layer = e.target;
						if (Sesion.estado.mapType === config.mapConfig.mapType[1]) // capa satélite
							layer.setStyle({
								fillOpacity: 0.3, //0.2,
								weight: 1.2 //0.9
							});
						else
							layer.setStyle({
								fillOpacity: 0.4,
								weight: 1.5
							});
					},
					popupclose: function(e) { // quitar realce
						let layer = e.target;
						if (Sesion.estado.mapType === config.mapConfig.mapType[1]) // capa satélite
							layer.setStyle({
								fillOpacity: 0.05, //0.1,
								weight: 0.4 //0.3
							});							
						else
							layer.setStyle({
								fillOpacity: 0.3,
								weight: 0.5
							});
					}
				});
				Sesion.tesPintadas[iri].openPopup(latlng);
			}
		}
	});
}


////////////
// MAPA BASE
function obtenerConfigMapaBase() {
	if (Sesion.estado.mapType === config.mapConfig.mapType[1]) // "satellite"
		return config.geoConfigs.esri;
	else	// "default"
		return config.geoConfigs.voyager;
}

function actualizarMapaBase() {
	const gcnew = obtenerConfigMapaBase();
	// borro atribuciones del mapa
	for (let clave of Object.keys(Mimapa.attributionControl._attributions))
		Mimapa.attributionControl.removeAttribution(clave);
	// elimino tileLayer anterior
	Mimapa.removeLayer(Mitilelayer);
	// pongo tileLayer nuevo
	Mitilelayer = gcnew.wms? L.tileLayer.wms(gcnew.url, gcnew.options).addTo(Mimapa) 
		: L.tileLayer(gcnew.url, gcnew.options).addTo(Mimapa);
	// el cambio de URL no sirve para reajustar el maxNativeZoom, así que simplemente pongo un tileLayer nuevo
	/*
	// borro atribuciones del mapa
	for (let clave of Object.keys(Mimapa.attributionControl._attributions))
		Mimapa.attributionControl.removeAttribution(clave);
	// compruebo si hay que cambiar sólo la URL o si hay que regenerar Mitilelayer
	const gcnew = obtenerConfigMapaBase();
	if (!gcold || gcold.wms == gcnew.wms) {
		// cambio la URL
		Mitilelayer.setUrl(gcnew.url);
		// pongo la nueva atribución
		Mimapa.attributionControl.addAttribution(gcnew.options.attribution);
	}
	else {
		// elimino tileLayer anterior
		Mimapa.removeLayer(Mitilelayer);
		// pongo tileLayer nueva
		Mitilelayer = gcnew.wms? L.tileLayer.wms(gcnew.url, gcnew.options).addTo(Mimapa) 
			: L.tileLayer(gcnew.url, gcnew.options).addTo(Mimapa);
	}*/
}


////////////////////////////
// CAPA DEL MFE50 (actualizar para otros mapas)
function getMapLayer(zoom) {
	for (const ml of config.mapLayers) {
		if (ml.zmin <= zoom && ml.zmax >= zoom)
			return ml;	
	}
	return null;
}


////////////////////////////
// BUCLE DE CONTROL DEL MAPA
function mapaMovido() {
	if (!Sesion.errordataprov) {
		if (Sesion.actualizandoMapa) {
			Sesion.mapaMovido = true; // pendiente de actualizar el mapa...
			console.log("Mapa movido: actualización de mapa pendiente...");
		}
		else // llamo a actualizar el mapa
			actualizarMapa();
	}
}
async function actualizarMapa() {
	// si no estoy en modo mapa no continúo con la actualización
	if (Sesion.estado.path !== "map")
		return;
	
	// actualizo zoom
	const zoomPrevio = Sesion.zoom;
	Sesion.zoom = Mimapa.getZoom();
	
	// detecto si hay que revisar las parcelas con múltiples secciones por cambio de zoom
	const revisarParcelasMulti = (zoomPrevio >= config.zParcelaMulti && Sesion.zoom < config.zParcelaMulti) ||
		(zoomPrevio < config.zParcelaMulti && Sesion.zoom >= config.zParcelaMulti);
		
	// obtengo grid de celdas para el mapa
	// limito el zoom en las celdas para evitar explosión en zooms muy altos que no aportan nada
	const zoomCelda = Sesion.zoom > config.zMaxCelda? config.zMaxCelda : Sesion.zoom;
	Sesion.zoomUsados[zoomCelda] = true; // para el cacheo
	const grid = getGrid(Mimapa.getBounds(), zoomCelda);
	
	// inicializaciones progreso y estadísticos
	Sesion.infoTeselas = {
		celdas: (1 + grid.cellE - grid.cellW) * (1 + grid.cellN - grid.cellS),
		cambioCapa: getMapLayer(zoomPrevio) !== getMapLayer(Sesion.zoom),
		celdasMediadas: [],
		teselasTotales: 1000, // para que no sea 0
		teselasCompletadas: 0,
		teselasPintadas: 0,
		urlsRed: [],
		urlsCache: [],
		pintar: false // preinicializo
	};
	Sesion.infoParcelas = {
		celdas: (1 + grid.cellE - grid.cellW) * (1 + grid.cellN - grid.cellS),
		celdasCompletadas: [],
		celdasArbolesCompletadas: [],
		parcelasCompletadas: [],
		parcelasArbolesCompletadas: [],
		urlsRed: [],
		urlsCache: [],
		ifn: Sesion.estado.ifn, // versión del ifn
		modoArbol: Sesion.zoom >= config.zArbol,
		pintar: Sesion.estado.plots && Sesion.zoom >= config.zParcela
	};
	Sesion.progreso = pintarBarraProgreso;

	
	// inicialización primordial
	inicioActualizarMapa();
	const idtimeout = Sesion.idTimeoutActualizar;
	
	// actualizo info celdas para GA
	setEventData('num_cells', Sesion.infoParcelas.celdas);
	
	// array de promesas global
	let promesas = [];
		
	/* TODO: pinto
	for (let x=grid.cellW; x<=grid.cellE; x++) {
		for (let y=grid.cellS; y<=grid.cellN; y++) {
			const cb = getCeldaBounds(x, y, Sesion.zoom);
			L.rectangle(cb, {color: "#ff7800", weight: 1}).addTo(Mimapa);
		}
	}*/	
	
	
	//
	// PROVINCIAS
	//
	// detecto si hay que mostrar las provincias o no
	if (Sesion.estado.mapDetails === "regions" || (Sesion.estado.mapDetails === "auto" && Sesion.zoom < config.zParcela))
		pintarProvincias();
	else
		quitarProvincias();
	
	/*
	//
	// MUNICIPIOS
	//
	// detecto si hay que mostrar los municipios o no
	// en modo automático con el mapa base satélite muestro los municipios a partir del zoom config.zParcela
	if (Sesion.estado.mapDetails === "munis" || (Sesion.estado.mapDetails === "auto" && Sesion.estado.mapType === "satellite" && Sesion.zoom >= config.zParcela))
		cargarMunis(true);
	else
		quitarMunis();*/
		
	//
	// TESELAS
	//
	// detecto si hay que mostrar las teselas
	//if (Sesion.estado.layer === "landcover")
	if (Sesion.estado.mapDetails === "patches" || 
			(Sesion.estado.mapDetails === "auto" && Sesion.estado.mapType === "default" && Sesion.zoom >= config.zParcela)) {
		Sesion.infoTeselas.pintar = true;		
	}
	// procesamiento teselas	
	if (!Sesion.infoTeselas.pintar)
		quitarTeselas(); // fuera teselas del mapa
	else {
		// inicializo array de promesas celdas para luego coordinar
		let dpcpromises = [];
		let objceldas = [];
		// trabajo celda a celda
		for (let x=grid.cellW; x<=grid.cellE; x++) {
			for (let y=grid.cellS; y<=grid.cellN; y++) {
				// preparo objeto de la celda
				const objcelda = {
					zoom: zoomCelda,
					cellX: x,
					cellY: y,
					et: 'z' + zoomCelda + '_x' + x + '_y' + y,
					idtimeout: idtimeout // para actualizar Sesion.infoTeselas sólo si toca
				};
				// guardo objcelda
				objceldas.push(objcelda);
				// hago la petición para descubrir las teselas de la celda
				dpcpromises.push( discoverPatchesInCell(objcelda, Sesion) );
			}
		}
		
		// limpieza de teselas si hay cambio de capa y si no borro las teselas no visibles
		if (Sesion.infoTeselas.cambioCapa) {
			quitarTeselas();
			delete Sesion.infoTeselas.cambioCapa; // no hace falta repetir
		}
		else {
			console.time("Borrado de teselas");		
			const gridBounds = getGridBounds(grid, zoomCelda);
			let turisBorrar = [];
			for (let turi in Sesion.tesPintadas) {
				// caso raro: hueco de tesela reservado, pero no pintado (tendrá un true), simplemente borro el hueco
				if (Sesion.tesPintadas[turi] && typeof Sesion.tesPintadas[turi] !== 'object')
					delete Sesion.tesPintadas[turi];
				else {
					const tbounds = Sesion.tesPintadas[turi].getBounds();
					if (!gridBounds.intersects(tbounds) && !gridBounds.contains(tbounds) )
						turisBorrar.push(turi);
				}
			}
			console.info("#teselas pintadas: " + Object.keys(Sesion.tesPintadas).length + " - #teselas a borrar: " + turisBorrar.length);
			for (let turib of turisBorrar) {
				Layers.tess.removeLayer(Sesion.tesPintadas[turib]);
				delete Sesion.tesPintadas[turib];
				delete Sesion.tesPopupsRegenerar[turib];
			}
			console.timeEnd("Borrado de teselas");
		}
		
		// llamo al procesador de teselas (que actuará una vez que recupere todas las teselas de las celdas)
		promesas.push( processPatches(idtimeout, objceldas, dpcpromises, Sesion) );
	}
		
	
	//
	// PARCELAS Y ÁRBOLES
	//	
	// procesamiento parcelas y árboles
	if (!Sesion.infoParcelas.pintar) {
		// fuera parcelas y árboles del mapa
		quitarParcelas();
		quitarArboles();
	}
	else {
		// ajuste radio parcela en modo no árbol
		if (!Sesion.infoParcelas.modoArbol) {		
			// calculo radio para pintar según el zoom
			const radio = Sesion.zoom > config.zCambioRadio? config.radioParcela - (config.radioParcela - config.radioParcelaN3)*(Sesion.zoom - config.zCambioRadio)/(config.zArbol - config.zCambioRadio)
				 : config.radioParcela;
			// si no coincide el radio con el de la sesión, me cargo la capa
			if (radio != Sesion.radioParPintadas)
				quitarParcelas();
			// guardo radio sesión
			Sesion.radioParPintadas = radio;
		}		
		
		// limpieza de árboles y parcelas según el modo
		const gridBounds = getGridBounds(grid, zoomCelda);
		let purisBorrar = [];
		if (Sesion.infoParcelas.modoArbol) {
			quitarParcelas(); // quita las parcelas del modo parcela			
			console.time("Borrado de parcelas árboles");		
			// detección de parcelas a borrar
			for (let puri in Sesion.parcarbPintadas) {
				if (Datos.parcelas[puri].ifn !== Sesion.infoParcelas.ifn) // fuera si distinta versión
					purisBorrar.push(puri);
				else {	// extraigo coordenadas del círculo exterior para detectar si se muestra o no
					const cbounds = Sesion.parcarbPintadas[puri][0].getBounds();
					if (!gridBounds.intersects(cbounds) && !gridBounds.contains(cbounds) )
						purisBorrar.push(puri);
				}
			}
			console.info("#parcelas pintadas: " + Object.keys(Sesion.parcarbPintadas).length + " - #parcelas a borrar: " + purisBorrar.length);
			// vamos con el borrado	parcela a parcela	
			for (let purib of purisBorrar) {
				// borrado círculos
				for (let pc of Sesion.parcarbPintadas[purib])
					Layers.arbs.removeLayer(pc);
				// borrado árboles
				for (let arburi of Datos.parcelas[purib].arbs) {
					if (Sesion.arbPintados[arburi]) {
						Layers.arbs.removeLayer(Sesion.arbPintados[arburi]);
						delete Sesion.arbPintados[arburi];
					}
				}
				delete Sesion.parcarbPintadas[purib];
			}
			console.timeEnd("Borrado de parcelas árboles");
		}
		else  {
			quitarArboles(); // quita los círculos y los árboles del modo árbol			
			console.time("Borrado de parcelas");		
			// detección de parcelas a borrar
			for (let puri in Sesion.parPintadas) {
				if (Datos.parcelas[puri].ifn !== Sesion.infoParcelas.ifn) // fuera si distinta versión
					purisBorrar.push(puri);
				else {	// miro coordenadas
					const pbounds = Array.isArray(Sesion.parPintadas[puri])? Sesion.parPintadas[puri][0].getBounds() : Sesion.parPintadas[puri].getBounds();
					if (!gridBounds.intersects(pbounds) && !gridBounds.contains(pbounds) )
						purisBorrar.push(puri);
				}
			}
			console.info("#parcelas pintadas: " + Object.keys(Sesion.parPintadas).length + " - #parcelas a borrar: " + purisBorrar.length);
			// vamos con el borrado	parcela a parcela	
			for (let purib of purisBorrar) {
				if (Array.isArray(Sesion.parPintadas[purib])) {
					for (let parelb of Sesion.parPintadas[purib])
						Layers.parcs.removeLayer(parelb);
				}
				else			
					Layers.parcs.removeLayer(Sesion.parPintadas[purib]);
				delete Sesion.parPintadas[purib];
				delete Sesion.parPintadasMulti[purib];
				delete Sesion.parPopupsRegenerar[purib];
			}
			console.timeEnd("Borrado de parcelas");
			
			if (revisarParcelasMulti) {
				console.info("#parcelas multi revisar: " + Object.keys(Sesion.parPintadasMulti).length);
				ajustarColorParcelas(Object.keys(Sesion.parPintadasMulti));			
			}
		}
		
		// ahora utilizo el array de promesas global
		// inicializo array de promesas celdas para luego coordinar
		//let dpcpromises = [];
		//let objceldas = []; // => ya no hace falta
		// trabajo celda a celda
		for (let x=grid.cellW; x<=grid.cellE; x++) {
			for (let y=grid.cellS; y<=grid.cellN; y++) {
				// preparo objeto de la celda
				const objcelda = {
					zoom: zoomCelda,
					cellX: x,
					cellY: y,
					et: 'z' + zoomCelda + '_x' + x + '_y' + y + '_' + Sesion.infoParcelas.ifn,
					ifn: Sesion.infoParcelas.ifn,
					modoArbol: Sesion.infoParcelas.modoArbol,
					idtimeout: idtimeout // para actualizar Sesion.infoTeselas sólo si toca
				};
				// guardo objcelda => ya no hace falta
				//objceldas.push(objcelda);
				// hago la petición para descubrir las parcelas de la celda (previo)
				//dpcpromises.push( discoverPlotsInCell(objcelda, Sesion) );
				// ahora utilizo el array de promesas global
				promesas.push( discoverPlotsInCell(objcelda, Sesion) );
			}
		}
		
		// esto ya no hace falta al hacerlo todo de un paso en discoverPlotsInCell
		// llamo al procesador de parcelas (que actuará una vez que recupere todas las parcelas de las celdas)
		//promesas.push( processPlots(idtimeout, objceldas, dpcpromises, Sesion) ); 
	}	
	
	// espero a que terminen todas las promesas de las celdas para hacer logging
	await Promise.all(promesas);
	
	// logging si no ha vencido el temporizador de actualización...
	if (idtimeout == Sesion.idTimeoutActualizar) {
		let ured = 0;
		let ucache = 0;
		// logging teselas
		if (Sesion.infoTeselas.pintar) {
			const urlsRed = Sesion.infoTeselas.urlsRed.reduce((memo, num) => memo + num, 0);
			const urlsCache = Sesion.infoTeselas.urlsCache.reduce((memo, num) => memo + num, 0);
			ured += urlsRed;
			ucache += urlsCache;
			console.info("teselas I" + Sesion.idTimeoutActualizar  + " #celdas: " + Sesion.infoTeselas.celdas + 
				" #teselas: " + Sesion.infoTeselas.teselasTotales + " #teselas cargadas: " + Sesion.infoTeselas.teselasCompletadas +
				" #teselas pintadas: " + Sesion.infoTeselas.teselasPintadas + 
				" #urlsRed: " + urlsRed + " #urlsCache: " + urlsCache);
		}
		// logging celdas parcelas
		if (Sesion.infoParcelas.pintar) {
			const urlsRed = Sesion.infoParcelas.urlsRed.reduce((memo, num) => memo + num, 0);
			const urlsCache = Sesion.infoParcelas.urlsCache.reduce((memo, num) => memo + num, 0);
			ured += urlsRed;
			ucache += urlsCache;
			const plistas = Sesion.infoParcelas.modoArbol? Sesion.infoParcelas.parcelasArbolesCompletadas : Sesion.infoParcelas.parcelasCompletadas;
			const npl = plistas.reduce((memo, num) => memo + num, 0);
			const ppintadas = Sesion.infoParcelas.modoArbol? Sesion.parcarbPintadas : Sesion.parPintadas;
			const npp = Object.keys(ppintadas).length;
			console.info("parcelas I" + Sesion.idTimeoutActualizar  + " #celdas: " + Sesion.infoParcelas.celdas + 
				" #parcelas: " + npl + " #parcelas pintadas: " + npp + 
				" #urlsRed: " + urlsRed + " #urlsCache: " + urlsCache);
		}	
		// actualizo info urls para GA
		setEventData('urls_network', ured);
		setEventData('urls_cache', ucache);			
	}
		
	// rutina fin actualización del mapa si no ha vencido el temporizador de actualización
	if (idtimeout == Sesion.idTimeoutActualizar) {
		finActualizarMapa();
		
		// muestro tostada IFN2 (primera vez en la sesión)
		if (tostadaIFN2pend && Sesion.estado.ifn === "ifn2") {		
			// aviso con una tostada de agujeros en el IFN2
			document.getElementById("mitostadaStrong").innerHTML = getLiteral(dict.title);
			document.getElementById("mitostadaBody").innerHTML = getLiteral(dict.toastIFN2);
			const tostada = bootstrap.Toast.getOrCreateInstance(document.getElementById('mitostada'));
			tostada.show();
			// ya no muestro más		
			tostadaIFN2pend = false;
		}	
	}
}
function inicioActualizarMapa() {
	// mapa actual
	Sesion.mapaMovido = false;
	// quito timeout anterior (importante llamar tras Sesion.mapaMovido = false)
	finActualizarMapa();
	// pongo bloqueo a actualizaciones
	Sesion.actualizandoMapa = true;
	
	// pinto la barra de progreso
	pintarBarraProgreso(true, Sesion);
	
	// actualizo la localización del estado de la sesión
	Sesion.estado.loc.lat = Mimapa.getCenter().lat;
	Sesion.estado.loc.lng = Mimapa.getCenter().lng;
	Sesion.estado.loc.z = Mimapa.getZoom();
		
	// reajusto url y actualizo página en la historia si hay cambio en URL
	if (window.location !== obtenerURL())
		history.replaceState(Sesion.estado, "", obtenerURL());
	
	// ajuste propiedad meta de la url
	document.querySelector("meta[property='og:url']").setAttribute('content', window.location.href);	
	
	// pongo timeout para que quite el bloqueo tras 10 segundos (por si acaso se bloquea indefinidamente)
	Sesion.idTimeoutActualizar = setTimeout(function(){	
		// mando evento de timeout a GA	
		sendMapTimeoutEvent();
		
		console.warn("Venció el temporizador de " +  Math.round(Sesion.timeout/1000) + " segundos antes de terminar de actualizar el mapa");
		// logging teselas
		if (Sesion.infoTeselas.pintar) {
			const urlsRed = Sesion.infoTeselas.urlsRed.reduce((memo, num) => memo + num, 0);
			const urlsCache = Sesion.infoTeselas.urlsCache.reduce((memo, num) => memo + num, 0);
			console.info("teselas I" + Sesion.idTimeoutActualizar  + " #celdas: " + Sesion.infoTeselas.celdas + 
				" #teselas: " + Sesion.infoTeselas.teselasTotales + " #teselas cargadas: " + Sesion.infoTeselas.teselasCompletadas +
				" #teselas pintadas: " + Sesion.infoTeselas.teselasPintadas + 
				" #urlsRed: " + urlsRed + " #urlsCache: " + urlsCache);
		}
		// logging celdas parcelas
		if (Sesion.infoParcelas.pintar) {
			const urlsRed = Sesion.infoParcelas.urlsRed.reduce((memo, num) => memo + num, 0);
			const urlsCache = Sesion.infoParcelas.urlsCache.reduce((memo, num) => memo + num, 0);
			const plistas = Sesion.infoParcelas.modoArbol? Sesion.infoParcelas.parcelasArboles : Sesion.infoParcelas.parcelasCompletadas;
			const npl = plistas.reduce((memo, num) => memo + num, 0);
			const ppintadas = Sesion.infoParcelas.modoArbol? Sesion.parcarbPintadas : Sesion.parPintadas;
			const npp = Object.keys(ppintadas).length;
			console.info("parcelas I" + Sesion.idTimeoutActualizar  + " #celdas: " + Sesion.infoParcelas.celdas + 
				" #parcelas: " + npl + " #parcelas pintadas: " + npp + 
				" #urlsRed: " + urlsRed + " #urlsCache: " + urlsCache);
		}			
		console.groupEnd();
		
		Sesion.actualizandoMapa = false;
		Sesion.idTimeoutActualizar = null;
		// actualizo timeout
		Sesion.timeout += config.timeoutStep;
		Sesion.huboTimeout = true;		
		// y llamo a mapaMovido
		mapaMovido();
	}, Sesion.timeout);
	// logging
	console.group("I" + Sesion.idTimeoutActualizar + " - Actualizando mapa");
	console.time("Actualización I" + Sesion.idTimeoutActualizar);
	console.log("URL: " + window.location);
	console.log("Temporizador actualización: " +  Math.round(Sesion.timeout/1000) + " segundos")
	//console.log(" -> bloqueando actualizaciones y poniendo temporizador antibloqueo: " + Sesion.idTimeoutActualizar);
		
	// inicializo el evento para enviar a Google Analytics
	initMapEvent();
}
function finActualizarMapa() {
	//console.log(" -> fin de actualización del mapa, quito temporizador antibloqueo");
	Sesion.actualizandoMapa = false; // quito bloqueo
	// cancelo timeout anterior (si existiera)
	if (Sesion.idTimeoutActualizar != null) {
		clearTimeout(Sesion.idTimeoutActualizar);
		console.timeEnd("Actualización I" + Sesion.idTimeoutActualizar);
		console.info("I" + Sesion.idTimeoutActualizar + " - Fin actualización del mapa");
		console.groupEnd();
		Sesion.idTimeoutActualizar = null;
		// escondo la barra de progreso
		pintarBarraProgreso(false, Sesion);
		// actualización timeout
		if (!Sesion.huboTimeout && Sesion.timeout > config.timeout) // si no hubo timeout resto config.timeoutStep (sin superar el valor inicial)
			Sesion.timeout -= config.timeoutStep;
		Sesion.huboTimeout = false; // inicializo para la siguiente
		// mando evento de fin de actualización del mapa
		sendTimedEvent();		
	}
			
	// llamo a actualizar el mapa si es necesario
	if (Sesion.mapaMovido) {
		console.info("El mapa se había movido, vuelvo a actualizar");
		mapaMovido();
	}
	else if (Sesion.ponerAlertaCuestionario) {
		// miro si pongo el cuestionario
		const ahora = Date.now();
		if (ahora - Sesion.inicioSesion > config.intraSessionQGap) {
			// pongo el cuestionario
			document.getElementById("mimapa").insertAdjacentHTML("beforeend", alertQuestionnaireTemplate);
			// ya no lo vuelvo a poner en la sesión
			Sesion.ponerAlertaCuestionario = false;
			// y pongo los handlers de los botones
			document.getElementById("questbotyes").addEventListener("click", function() {
				// vamos al questionario (nueva pestaña)
				const questurl = this.getAttribute("questurl");
				const win = window.open(questurl, '_blank');
				win.focus();
				// no más cuestionarios
				localStorage.setItem('cuestionarioNo', true);
				// quito la alerta
				document.getElementById("questalert").remove();
			});
			document.getElementById("questbotno").addEventListener("click", function() {
				// reajusto a ahora más 3 semanas
				const nuevo = ahora + 21*24*3600*1000;
				localStorage.setItem('timestampPrimeraSesion', nuevo);
				// quito la alerta
				document.getElementById("questalert").remove();
			});
			document.getElementById("questbotlater").addEventListener("click", function() {
				// reajusto a ahora 
				localStorage.setItem('timestampPrimeraSesion', ahora);
				// quito la alerta
				document.getElementById("questalert").remove();
			});
		}
	}
}

function pintarBarraProgreso(mostrar, sesion) {
	const mibarradiv = document.getElementById('mibarradiv');
	if (mostrar) {
		let mibarra = document.getElementById('mibarra');
		let total = 0;
		let comp = 0;
		// teselas
		if (sesion.infoTeselas.pintar) {			
			total += 100;
			const celdasmed = sesion.infoTeselas.celdasMediadas.reduce((memo, num) => memo + num, 0);
			if (sesion.infoTeselas.teselasTotales == 0)
				comp += 100*celdasmed/sesion.infoTeselas.celdas;
			else {
				comp += (30*celdasmed/sesion.infoTeselas.celdas 
					+ 40*sesion.infoTeselas.teselasCompletadas/sesion.infoTeselas.teselasTotales
					+ 30*sesion.infoTeselas.teselasPintadas/sesion.infoTeselas.teselasTotales); // de 0 a 100
			}
		}
		// parcelas
		if (sesion.infoParcelas.pintar) {
			total += 100;
			const clistas = sesion.infoParcelas.celdasCompletadas.reduce((memo, num) => memo + num, 0);
			comp += 100*clistas/sesion.infoParcelas.celdas;
			if (sesion.infoParcelas.modoArbol) {
				total += 40;
				const carblistas = sesion.infoParcelas.celdasArbolesCompletadas.reduce((memo, num) => memo + num, 0);
				comp += 40*carblistas/sesion.infoParcelas.celdas;
			}
		}
		// calculo porc (hasta 99)
		const porc = total == 0? 0 : Math.floor( 99 * comp / total );
		//console.log("Progreso: " + porc + " - total: " + total + " - comp: " + comp);
		// ajusto barra
		mibarradiv.setAttribute('aria-valuenow', porc);
		mibarra.style.width = porc + '%';
		mibarra.innerHTML = porc + '%';
		// mensajillo de cargando
		let mibarraLoading = document.getElementById('mibarra_loading');
		const porcLoading = 100 - porc;
		if (porcLoading > 30) {
			mibarraLoading.classList.remove('d-none');
			mibarraLoading.style.width = porcLoading + '%';
		}
		else
			mibarraLoading.classList.add('d-none');
		// muestro la barra de progreso
		mibarradiv.classList.remove('d-none');
	} 
	else  // escondo la barra
		mibarradiv.classList.add('d-none');	
}

export { Mimapa, inicializarMapa, getMapLayer, mapaMovido, finActualizarMapa, actualizarMapaBase };